import serviceCommon from './common';
// import { WebAuth } from '@chehejia/authli-js';
// import localStoragePerfect from '@/util/localstorage-perfect';
// import { clientId, qiyuClientId } from '@/util/idaasOption';
// import ajaxId from '@/util/ajax-id';

const checkLoginUrl = '/aisp-account-api/v1-0/token-status'; // 校验登录状态
const logoutUrl = '/aisp-account-api/v1-0/logout'; // 登出
const getUserInfoUrl = '/aisp-account-api/v1-0/profile';

// const idaasLogoutUrl = '/logout'; // idaas退出登录

// const idaasLogoutUrl = '/logout'; // idaas退出登录

export default {
    // 校验登录状态
    async checkLogin() {
        const response = await serviceCommon.serviceAjax(
            checkLoginUrl,
            'get',
            {},
            {
                throwError: false
            }
        );
        return response;
    },
    // 获取用户信息
    async getUserInfo() {
        const response = await serviceCommon.serviceAjax(
            getUserInfoUrl,
            'get',
            {},
            {
                throwError: false
            }
        );
        return response;
    },
    // 退出登录
    async logout() {
        const res = await serviceCommon.serviceAjax(logoutUrl, 'post');

        // 同时调用七鱼sdk登出
        // try {
        //     const ysffn = localStoragePerfect.getItem('ysffn');
        //     if (ysffn) {
        //         const useEval = (fn: any) => {
        //             const Fun = Function;
        //             return new Fun(`return ${fn}`)();
        //         };
        //         const ysf = useEval(ysffn);
        //         ysf('logoff');
        //     }
        // } catch (error) {
        //     console.log('qiyu logout error', error);
        // }

        // 调用idaas-sdk七鱼aud登出
        // try {
        //     const { env }: any = window.globalData;

        //     const auth = new WebAuth({
        //         env,
        //         clientId: qiyuClientId
        //     });
        //     await auth.logout({
        //         localOnly: true // 清除本地缓存
        //     });
        // } catch (error) {
        //     console.log('idaas-qiyu-logout error', error);
        // }

        // 同时调用idaas登出
        // try {
        //     const { response } = await ajaxId.post(idaasLogoutUrl, {
        //         client_id: clientId,
        //         federated: true
        //     });
        //     console.log('idaas-logout response', response);
        // } catch (error) {
        //     console.log('idaas-logout error', error);
        // }

        return res;
    }
};
